import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface BrokerInfoState {
  riaCode: string;
  euinCode: string;
  agent: string;
}

const initialState: BrokerInfoState = {
  riaCode: "",
  euinCode: "",
  agent: "",
};

const brokerInfoSlice = createSlice({
  name: "brokerInfo",
  initialState,
  reducers: {
    setRiaCode: (state, action: PayloadAction<string>) => {
      state.riaCode = action.payload;
    },
    setEuinCode: (state, action: PayloadAction<string>) => {
      state.euinCode = action.payload;
    },
    setAgent: (state, action: PayloadAction<string>) => {
      state.agent = action.payload;
    },
    clearBrokerInfo: (state) => {
      state.riaCode = "";
      state.euinCode = "";
      state.agent = "";
    },
    setBrokerInfo: (state, action: PayloadAction<BrokerInfoState>) => {
      state.riaCode = action.payload.riaCode;
      state.euinCode = action.payload.euinCode;
      state.agent = action.payload.agent;
    },
  },
});

export const { setRiaCode, setEuinCode, setAgent, clearBrokerInfo, setBrokerInfo } =
  brokerInfoSlice.actions;

export default brokerInfoSlice.reducer;
